import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var RewindBeginning = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.76.82c-.4-.2-.8-.1-1.1.201L12.641 20.063V1.423c0-.602-.5-1.003-1-1.003-.601 0-1.001.501-1.001 1.002v41.691c0 .601.5 1.002 1 1.002.601 0 1.001-.5 1.001-1.002v-18.04L31.66 44.116c.3.3.7.401 1.101.2.4-.2.6-.5.6-1.002V1.823c0-.4-.2-.802-.6-1.002ZM31.36 41.009l-18.316-18.34 18.316-18.34v36.68Z"
  }));
});
RewindBeginning.displayName = 'RewindBeginning';
RewindBeginning.defaultProps = {
  'aria-label': 'RewindBeginning'
};
export default RewindBeginning;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/RewindBeginning.js
// module id = 3895
// module chunks = 11